import Vue from "vue";


const store = Vue.observable({
    requests: {
        loaded: false,
        data: {
            cases: []
        }
    }
});

const actions = {
    async getRequests() {
        let result;
        store.requests.loaded = false;
        try {
          result = await Vue.axios.get(`fleet/requests`);
        }
        catch(err) {
          result = err;
        }
        if (!result && result.error) return;
        store.requests.data = result;
        store.requests.loaded = true;
    },
    async modifyRequest(action, caseId) {
        let statuses = {
            approve: 'approved',
            reject: 'rejected'
        }
        let result;
        try {
          result = await Vue.axios.put(`fleet/request`, {action, caseId});
        }
        catch(err) {
          result = err;
        }
        console.log('api resp', result);
        if (result && result.status && result.status === 'success') {
            store.requests.data.cases.find(c => c._id === caseId).metadata.reviewStatus = statuses[action];
            return;
        }
        if (result && result.info && result.info.message) return result.info.message;
        
        return 'error'

    },
    async sendActivity(text, caseId) {

        let result;
        try {
          result = await Vue.axios.post(`fleet/new_activity`, {text, caseId});
        }
        catch(err) {
          result = err;
        }
        console.log('api resp', result);
        if (result && result.status && result.status === 'success' && result.activity) {
            store.requests.data.cases.find(c => c._id === caseId).activities.push(result.activity);
            return;
        }
        if (result && result.info && result.info.message) return result.info.message;
        
        return 'error'

    }

}

export default {
    store,
    actions
}